import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, LineElement, PointElement } from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    LineElement,
    PointElement
);

const EmissionsBarLine = () => {
    const data = {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        datasets: [
            {
                type: 'bar',
                label: 'Sessions',
                data: [5000, 7500, 6000, 4000, 6500, 5000, 7000, 4500, 5000, 4000, 6000, 8000],
                backgroundColor: 'rgba(54, 162, 235, 0.8)', // Blue color for bars
                borderColor: 'rgba(54, 162, 235, 1)',
                borderWidth: 1,
            },
            {
                label: 'New Users',
                data: [3000, 4500, 4000, 3000, 4000, 3000, 5000, 3500, 4500, 3500, 5000, 6000],
                backgroundColor: '#cedcf7',  // Light blue for Green Energy Stats bars
                borderColor: '#cedcf7',
                borderWidth: 1,
            },
            {
                type: 'line',
                label: 'Users',
                data: [5000, 7500, 6000, 4000, 6500, 5000, 7000, 4500, 5000, 4000, 6000, 8000].map(e => e + 500),
                borderColor: 'rgba(153, 102, 255, 1)', // Line color
                backgroundColor: 'rgba(153, 102, 255, 0.5)',
                fill: false,
                stepped: 'middle', // This makes the line look stepped
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            tooltip: {
                mode: 'index',
                intersect: false,
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                max: 10000,
            },
        },
    };

    return (
        <div className='card'>
            <div className='card-body'>
                <h4>Emissions</h4>
                <Bar data={data} options={options} />
            </div>
        </div>
    );
}; 

export default EmissionsBarLine;
